import {Component, Inject, OnInit} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import {MatRadioGroup, MatRadioModule} from '@angular/material/radio';
import {MAT_DIALOG_DATA, MatDialogRef, MatRadioChange} from '@angular/material';
import { TradingPartnerService } from '../../../services/trading-partner.service';
import { ActivatedRoute, Router } from '@angular/router';
import {MatRadioButton} from '@angular/material/typings/radio';

@Component({
  selector: 'app-trading-partner-save-modal',
  templateUrl: './trading-partner-save-modal.component.html',
  styleUrls: ['./trading-partner-save-modal.component.scss'],
})
export class TradingPartnerSaveModalComponent implements OnInit {
  public formTradingPartnerSaveModal: FormGroup;
  contactEmails: any = [];
  companyId = '0';
  contactEmail: string;
  modifiedBy: any;
  public value: string;

  constructor(
      private tradingPartnerService: TradingPartnerService,
      private dialogRef: MatDialogRef<TradingPartnerSaveModalComponent>,
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      @Inject(MAT_DIALOG_DATA) data) {
        this.contactEmails = data.contactEmails;
  }

  ngOnInit() {
      this.formTradingPartnerSaveModal = this.formBuilder.group({
        modifiedBy: [this.contactEmails, [Validators.required]],
      });
    }

  onSubmit() {
    const selectedType = this.formTradingPartnerSaveModal.value.modifierEmail;
    this.closeDialog(selectedType);
  }

  closeDialog(value: string = '') {
    this.dialogRef.close(this.value);
  }

  onChange(event: MatRadioChange) {
    this.modifiedBy = event.value;
    this.value = event.value;
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/trading-partners/trading-partner-save-modal/trading-partner-save-modal.component.ts